"use strict";import t from"./src/spectrum-base.css.js";import e from"./src/spectrum-lang.css.js";import o from"./src/spectrum-detail.css.js";export default[t,e,o];
//# sourceMappingURL=detail.js.map
